import gql from 'graphql-tag';

const Mutation = {
  createAffaire: gql`
    mutation createAffaireWithOpportunityAssigmentId($opportunityAssignmentId: Int!, $skipAttributionService: Boolean) {
      createAffaireWithOpportunityAssigmentId(
        opportunityAssignmentId: $opportunityAssignmentId
        skipAttributionService: $skipAttributionService
      ) {
        id
        url
        isOpportunityAssigned
        message
      }
    }
  `,

  createAffaireFromOpportunity: gql`
    mutation createAffaire($opportunityId: Int!, $isReadyInPipe: Boolean) {
      createAffaire(opportunityId: $opportunityId, isReadyInPipe: $isReadyInPipe) {
        id
        url
        isOpportunityAssigned
        message
      }
    }
  `,

  rejectOpportunityAssignment: gql`
    mutation rejectOpportunityAssignmentId($opportunityAssignmentId: Int!) {
      rejectOpportunityAssignmentId(opportunityAssignmentId: $opportunityAssignmentId)
    }
  `,

  sendMLAUsingExternalId: gql`
    mutation sendMLAUsingExternalId($externalId: Int!) {
      sendMLAUsingExternalId(externalId: $externalId) {
        sent
        url
      }
    }
  `,
};

const Query = {
  getAgentAffaires: gql`
    query getAgentAffaires($email: String!) {
      getAgentAffaires(email: $email) {
        link
        externalAffaireId
        status
        agent
        createdAt
        id
        intermediary
      }
    }
  `,
};

export default {
  Mutation,
  Query,
};
